export enum FeatureFlagKeys {
  Use_CL_Test_RS_Date = 'Use_CL_Test_RS_Date',
  Use_CL_Fullvideo_Facerec = 'Use_CL_Fullvideo_Facerec',
  Use_CL_Fullvideo_Facerec_Pre_Recorded = 'Use_CL_Fullvideo_Facerec_Pre_Recorded',
  Use_CL_Splits_Translations = 'Use_CL_Splits_Translations',
  Use_CL_Screenshare_Detection = 'Use_CL_Screenshare_Detection',
  Use_CL_Init_New_Player_Config = 'Use_CL_Init_New_Player_Config',
  Use_CL_Face_Rec_To_Default_Position = 'Use_CL_Face_Rec_To_Default_Position',
  Use_CL_Person_Container = 'Use_CL_Person_Container',
  Use_CL_Platform_Brandkit = 'Use_CL_Platform_Brandkit',
  Use_CL_Editor_New_Layouts = 'Use_CL_Editor_New_Layouts'
}

export type FeatureFlagTypeMap = {
  Use_CL_Test_RS_Date: string;
  Use_CL_Fullvideo_Facerec: boolean;
  Use_CL_Fullvideo_Facerec_Pre_Recorded: boolean;
  Use_CL_Splits_Translations: boolean;
  Use_CL_Screenshare_Detection: boolean;
  Use_CL_Init_New_Player_Config: boolean;
  Use_CL_Face_Rec_To_Default_Position: boolean;
  Use_CL_Person_Container: boolean;
  Use_CL_Platform_Brandkit: boolean;
  Use_CL_Editor_New_Layouts: boolean;
};

export const FLAG_DEFAULTS: FeatureFlagTypeMap = {
  Use_CL_Test_RS_Date: '',
  Use_CL_Fullvideo_Facerec: false,
  Use_CL_Fullvideo_Facerec_Pre_Recorded: false,
  Use_CL_Splits_Translations: false,
  Use_CL_Screenshare_Detection: false,
  Use_CL_Init_New_Player_Config: false,
  Use_CL_Face_Rec_To_Default_Position: false,
  Use_CL_Person_Container: false,
  Use_CL_Platform_Brandkit: false,
  Use_CL_Editor_New_Layouts: false
};

export interface FeatureFlagLogger {
  warn(message: string, context: { flagName: FeatureFlagKeys }): void;
}

const noOpLogger: FeatureFlagLogger = {
  warn: () => undefined
};

export class FeatureFlags {
  private flags: FeatureFlagTypeMap;
  constructor(flags: FeatureFlagTypeMap, logger: FeatureFlagLogger = noOpLogger) {
    this.flags = flags;
    Object.values(FeatureFlagKeys).forEach(flagName => {
      if (!(flagName in this.flags)) {
        logger.warn('[FeatureFlags] Missing feature flag', { flagName });
      }
    });
  }

  public getFlag<K extends keyof FeatureFlagTypeMap>(flagName: K): FeatureFlagTypeMap[K] {
    return this.flags[flagName];
  }

  public getNumberFlag(flagName: FeatureFlagKeys) {
    const flagValue = Number(this.flags[flagName]);
    return flagValue;
  }
}
